<template>
  <a-modal
    :visible="visible"
    :title="title"
    @cancel="handleCancel"
    width="800px"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('直播课程.课程主图')" prop="courseMainImage">
        <OssUploadSingle v-model="form.courseMainImage" type="img" :maxSize="200"></OssUploadSingle>
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.课程轮播图')" prop="courseBannerImages">
        <OssUploadMulti v-model="form.courseBannerImages" :isArrayData="true" :max-count="5" prefix="livecourse" type="img"></OssUploadMulti>
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.课程标题')" prop="courseTitle">
        <a-input v-model="form.courseTitle" :maxLength="255" />
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.课程简介')" prop="courseIntroduction">
        <editor v-model="form.courseIntroduction" :height="200" />
      </a-form-model-item>

      <a-form-model-item :label="$t('直播课程.课程标签')" prop="courseTags">
        <a-select
          mode="multiple"
          placeholder="请选择课程标签"
          v-model="form.courseTags"
          style="width: 100%"
        >
          <a-select-option
            v-for="(d, index) in dict.type['live_course_tag']"
            :key="index"
            :value="d.label"
          >
            {{ d.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('直播课程.选择教师')" prop="teacherId">
        <a-select
          placeholder="请选择教师"
          v-model="form.teacherId"
          style="width: 100%"
          allow-clear
        >
          <a-select-option
            v-for="teacher in teacherList"
            :key="teacher.id"
            :value="teacher.id"
          >
            {{ teacher.teacherName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button @click="handleCancel">{{$t('通用.按钮.取消')}}</a-button>
      <a-button type="primary" @click="submitForm">{{$t('通用.按钮.确定')}}</a-button>
    </template>
  </a-modal>
</template>

<script>
import { getLiveCourse, addLiveCourse, updateLiveCourse } from '@/api/livecourse/liveCourse'
import { listAllLiveTeacher } from '@/api/livecourse/liveTeacher'
import OssUploadSingle from '@/components/OssUploadSingle'
import OssUploadMulti from "@/components/OssUploadMulti";
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle,
    OssUploadMulti,
    Editor
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  dicts: ['sys_user_sex', 'live_course_tag'],
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      visible: false,
      title: '',
      teacherList: [],
      form: {
        id: undefined,
        courseMainImage: undefined,
        courseBannerImages: [],
        courseTitle: undefined,
        courseIntroduction: undefined,
        courseRating: 0,
        courseTags: [],
        teacherId: undefined
      },
      rules: {
        courseMainImage: [{ required: true, message: '请上传课程主图', trigger: 'change' }],
        courseTitle: [{ required: true, message: '请输入课程标题', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    if (this.id) {
      this.handleUpdate(this.id)
    }
  },
  methods: {
    loadTeacherList() {
      listAllLiveTeacher().then(response => {
        this.teacherList = response.data || []
      })
    },
    handleAdd() {
      this.title = '新增直播课程'
      this.loadTeacherList()
      this.form = {
        id: undefined,
        courseMainImage: undefined,
        courseBannerImages: [],
        courseTitle: undefined,
        courseIntroduction: undefined,
        courseRating: 0,
        courseTags: [],
        teacherId: undefined
      }
      this.visible = true
    },
    handleUpdate(row) {
      this.title = '修改直播课程'
      this.loadTeacherList()
      const id = typeof row === 'object' ? row.id : row
      getLiveCourse({ id: id }).then(res => {
        this.form = { ...res.data }
        if (this.form.courseBannerImages) {
          try {
            this.form.courseBannerImages = JSON.parse(this.form.courseBannerImages)
          } catch (e) {
            this.form.courseBannerImages = []
          }
        } else {
          this.form.courseBannerImages = []
        }
        if (this.form.courseTags) {
          this.form.courseTags = this.form.courseTags.split(',')
        } else {
          this.form.courseTags = []
        }
        this.visible = true
      })
    },
    handleCancel() {
      this.visible = false
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = { ...this.form }
          if (data.courseBannerImages && data.courseBannerImages.length > 0) {
            data.courseBannerImages = JSON.stringify(data.courseBannerImages)
          } else {
            data.courseBannerImages = undefined
          }
          if (data.courseTags && data.courseTags.length > 0) {
            data.courseTags = data.courseTags.join(',')
          } else {
            data.courseTags = undefined
          }
          if (data.id) {
            updateLiveCourse(data).then(() => {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('ok')
            })
          } else {
            addLiveCourse(data).then(() => {
              this.$message.success('新增成功')
              this.visible = false
              this.$emit('ok')
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .adaptive {
  height: auto;
}
::v-deep .editor .w-e-text-container {
  height: 300px !important;
}
</style>
